import CONSTANT from '../config/constant'
import Utility from '../utility/Utility'
import LIB from '../utility/Library'

class ScrollHandler {
  init() {
    this.elm = {
      container: document.getElementById('container'),
      contents : document.getElementById('contents')
    }

    this.instances = []
    this.lastCalledTime = Utility.getUnixTime()
    this.targetY = 0
    this.scrolling = false
    this.pageScrolling = false
    this.pageScollDuration = 1400
    this.keyScrollHeight = 800
    this.timer = {
      scroll: null
    }
    this.stay = false
  }

  addInstances(...instances) {
    this.instances.push(...instances)
  }

  bindScroll() {
    window.addEventListener('scroll', (e) => {
      this.targetY = -pageYOffset
      this.run()
    })
  }

  triggerScroll(force) {
    if (force || this.elm.container.getAttribute('data-trigger-scroll')) {
      this.run()
    }
  }

  run() {
    const windowTop    = -this.targetY
    const windowBottom = windowTop + window.innerHeight - CONSTANT.SCROLL.PADDING

    clearTimeout(this.timer.scroll)
    this.timer.scroll = setTimeout(() => {
      this.callInstanceMethod('onScrollEnd', windowTop, windowBottom)
    }, CONSTANT.SCROLL.WAIT)

    setTimeout(() => this.callInstanceMethod('onScrollStart', windowTop, windowBottom), 1)
  }

  callInstanceMethod(methodName, ...args) {
    this.instances.forEach(instance => instance[methodName](...args))
  }
}

// export as singleton
export default new ScrollHandler()


// WEBPACK FOOTER //
// ./src/assets/js/motion/ScrollHandler.js